import { render, staticRenderFns } from "./wechatPicture.vue?vue&type=template&id=f1b8decc&scoped=true&"
import script from "./wechatPicture.vue?vue&type=script&lang=ts&"
export * from "./wechatPicture.vue?vue&type=script&lang=ts&"
import style0 from "./wechatPicture.vue?vue&type=style&index=0&id=f1b8decc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b8decc",
  null
  
)

export default component.exports